import { render, staticRenderFns } from "./ImageWithDnD.vue?vue&type=template&id=32a35b38&scoped=true&"
import script from "./ImageWithDnD.vue?vue&type=script&lang=ts&"
export * from "./ImageWithDnD.vue?vue&type=script&lang=ts&"
import style0 from "./ImageWithDnD.vue?vue&type=style&index=0&id=32a35b38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a35b38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VIcon,VImg,VRow,VTooltip})
